import type { ButtonUnstyledTypeMap } from "@mui/base/ButtonUnstyled";
import classnames from "classnames";
import type { FunctionComponent, HTMLProps } from "react";

import { ButtonStyled } from "./styles";

export type Props = ButtonUnstyledTypeMap["props"] & {
  className?: string;
  icon?: boolean;
  noStyle?: boolean;
  text?: boolean;
} & Omit<HTMLProps<HTMLButtonElement>, "as" | "ref">;

export const Button: FunctionComponent<Props> = ({
  children,
  className,
  icon,
  noStyle,
  text,
  ...props
}) => (
  <ButtonStyled
    {...props}
    className={classnames(
      {
        default: !text && !noStyle,
        icon,
        text,
      },
      className,
    )}
  >
    {children}
  </ButtonStyled>
);

Button.displayName = "Button";
